const CLASS_VERSION = {
  legacy: 1,
  kanban: 2,
}

export default CLASS_VERSION
